import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Form, Modal, Button } from "react-bootstrap";
import {
  AuthService,
  EventService,
  EventApplicationService,
  GlobalSettingService,
} from "../../../services";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { injectModels } from "../../../redux/injectModels";
import { routes } from "../../../constants/routes";
import Editor from "react-simple-wysiwyg";
import { ApplicationType, EventStatus } from "../../../constants/Enum";
import { globalConstant } from "../../../constants/globalConstant";
import { handleConsoleError } from "../../../utils/common-methods";

const PitchModel = {
  id: "",
  userId: "",
  eventId: "",
  pitchLength: "",
  pitchWidth: "",
  pitchTitle: "",
  description: "",
  amount: "",
  totalPitch: "",
  maxAllowed: "",
  refundable: false,
  isActive: false,
};

const CreatePitch = (props) => {
  const id = EventService.getPitchId();
  const navigate = useNavigate();
  const [pitchData, setPitchData] = useState({ ...PitchModel });
  const loginUser = AuthService.getLoginUser();
  const { eventId } = useParams();
  const [amountLabel, setAmountLabel] = useState("Pitch Amount");
  const [appType, setAppType] = useState(0);
  const [commitmentFee, setCommitmentFee] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [reduceAmount, setReduceAmount] = useState("");
  const [error, setReduceError] = useState();
  const [isPublished, setPublished] = useState(true);
  const [statusLabels, setStatuslabel] = useState([]);

  const {
    register,
    handleSubmit,
    reset,
    setError,
    watch,
    clearErrors,
    formState: { errors },
  } = useForm();

  const getEventCateringApplications = async (eventId) => {
    try {
      if (eventId) {
        const res = await EventApplicationService.getEventApplicationByEventId(
          eventId,
          "R",
        );
        if (res?.isSuccess && res?.data && res?.data?.length > 0) {
          const appTypeTemp = res?.data?.[0]?.applicationType;
          setAppType(appTypeTemp);
          if (appTypeTemp === ApplicationType.Tender) {
            setAmountLabel("Minimum Bid");
          }
          if (appTypeTemp === ApplicationType.Turnover) {
            const response = await GlobalSettingService.getGlobalSettingList();

            if (response?.isSuccess && response?.data?.length > 0) {
              const minAmount = response?.data?.find(
                (item) =>
                  item.keyName?.trim() ===
                  globalConstant.TURNOVER_COMMITMENT_FEE?.trim(),
              );
              if (minAmount) {
                setCommitmentFee(minAmount.keyValue);
              }
            }
            setAmountLabel("Commitment Fee");
          }
          if (appTypeTemp === ApplicationType.Bid) {
            setAmountLabel("Minimum Starting Bid");
          }
        }
      }
    } catch (error) {
      const message = handleConsoleError(error);
      toast.error(error?.message || message);
    }
  };

  const getPitchStatusLables = async () => {
    try {
      const response = await GlobalSettingService.getPitchStatuslabels();

      if (response?.isSuccess && response?.data?.length > 0) {
        setStatuslabel(response?.data);
      }
    } catch (error) {
      const message = handleConsoleError(error);
      toast.error(error?.message || message);
    }
  };

  const gePitch = async () => {
    try {
      if (eventId) {
        await Promise.all([
          getEvent(eventId),
          getEventCateringApplications(eventId),
          getPitchStatusLables(),
        ]);
      }
      const res = (id && (await EventService.getPitchById(id))) || [];
      const pitchMappedData = { ...PitchModel, ...res?.data };
      reset(pitchMappedData);
      setPitchData(pitchMappedData);
    } catch (error) {
      const message = handleConsoleError(error);
      toast.error(error?.message || message);
    }
  };
  useEffect(() => {
    gePitch();
  }, []);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const getEvent = async (eventId) => {
    const storedEvent = await EventService.getEventById(eventId);
    if (storedEvent && storedEvent.data) {
      const event = storedEvent.data;
      setPublished(
        id &&
          (event.eventStatusId === EventStatus.Published ||
            event.eventStatusId === EventStatus.InProgress ||
            event.eventStatusId === EventStatus.Completed),
      );
    }
  };

  const isNumberInRange = (value, min, max) => {
    if (value === "") return false;

    const regex = /^\d+(\.\d{1,2})?$/;
    const num = Number(value);

    return regex.test(value) && !isNaN(num) && num > min && num < max;
  };

  const handleInputChange = (e) => {
    setReduceAmount(e.target.value);
    if (isNumberInRange(e.target.value, 0, pitchData?.amount)) {
      setReduceError("");
    } else {
      //setReduceAmount("");
      setReduceError(
        `Please enter an amount greater than 0 and less than ${pitchData?.amount},with up to 2 decimal places.`,
      );
    }
  };
  const handleOpenModal = async (e) => {
    e.preventDefault();
    setReduceAmount(pitchData?.amount);
    setShowModal(true);
  };

  const onReducePrice = async (e) => {
    try {
      e.preventDefault();
      console.log("unitData :: ", pitchData);
      if (!isNumberInRange(reduceAmount, 0, pitchData?.amount)) {
        setReduceError(
          `Please enter an amount greater than 0 and less than ${pitchData?.amount},with up to 2 decimal places.`,
        );
        return;
      } else {
        setReduceError("");
      }
      let data = {
        id: pitchData.id,
        amount: reduceAmount,
      };
       props.application.setLoading(true);
      var response = await EventService.ReducePitchPrice(data);

      if (response?.isSuccess) {
      
        EventService.removePitchId();
        props.application.setLoading(false);
        toast.success(response?.message);
        navigate(routes.ACCOUNT_PITCHES.replace(":eventId", eventId));
      } else {
        props.application.setLoading(false);
        toast.error(response?.message);
      }
    } catch (error) {
      props.application.setLoading(false);
      const message = handleConsoleError(error);
      toast.error(error?.message || message);
    }
  };

  const onSubmit = async (data) => {
    try {
      if (
        appType === ApplicationType.Turnover &&
        parseFloat(data.amount) < commitmentFee
      ) {
        setError("amount", {
          message: `Please enter a commitment fee of £${commitmentFee} or more.`,
        });
        return;
      }
      let response = null;
      data.userId = loginUser?.id;
      data.eventId = eventId;
      data.description = pitchData?.description;
      data.refundable = pitchData?.refundable;
      data.isActive = pitchData?.isActive;
      props.application.setLoading(true);
      if (id) {
        response = await EventService.UpdatePitch(data);
      } else {
        response = await EventService.CreatePitch(data);
      }
      if (response?.isSuccess) {
        
        EventService.removePitchId();
         props.application.setLoading(false);
         toast.success(response?.message);
        navigate(routes.ACCOUNT_PITCHES.replace(":eventId", eventId));
      } else {
        props.application.setLoading(false);
        toast.error(response?.message);
      }
    } catch (error) {
      props.application.setLoading(false);
      const message = handleConsoleError(error);
      toast.error(error?.message || message);
    }
  };

  const handleChange = (e, cntName) => {
    //const name = "pitchLength";

    let inputValue = e.target.value;
    // Remove all non-numeric characters except the decimal point
    inputValue = inputValue.replace(/[^0-9.]/g, "");

    // Ensure that only one decimal point is allowed
    inputValue = inputValue.replace(/(\..*?)\..*/g, "$1");

    // Update the state with the sanitized value
    setPitchData({ ...pitchData, cntName: inputValue });

    const numericPattern = /^[+]?[0-9]*\.?[0-9]+$/; // Allows positive numbers, integers, and decimals

    // Validate if the value matches the numeric pattern and is greater than 0
    if (
      inputValue === "" ||
      (numericPattern.test(inputValue) && parseFloat(inputValue) > 0)
    ) {
      clearErrors(cntName); // Clear error message if input is valid
      if (
        cntName === "amount" &&
        appType === ApplicationType.Turnover &&
        parseFloat(inputValue) < commitmentFee
      ) {
        setError(cntName, {
          message: `Please enter a commitment fee of £${commitmentFee} or more.`,
        });
      }
    } else {
      setError(cntName, {
        message: "Please enter a valid numeric value greater than zero.",
      });
    }
  };

  const handleIsRefundable = (event) => {
    setPitchData({
      ...pitchData,
      refundable: event.target.checked ? true : false,
    });
  };

  const handleIsStatus = (event) => {
    setPitchData({
      ...pitchData,
      isActive: event.target.checked ? true : false,
    });
  };

  const handleDescription = (e) => {
    //e.preventDefault();
    const val = e.target.value;
    setPitchData({
      ...pitchData,
      description: val,
    });
  };

  return (
    <React.Fragment>
      {/* <section className="subscription-banner p-0">
        <div className="container">
          <h3>Pitches</h3>
        </div>
      </section> */}
      {isPublished && <p className="text-danger mb-3"><strong>Note::</strong> The pitch has been published. You can now updated the <strong>Display Status Label</strong> and <strong>Visibility Status.</strong></p>}
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Form.Group controlId="pitchTitle" className="mb-3">
          <Form.Label>
            Pitch Title <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            maxLength={100}
            type="text"
            {...register("pitchTitle", {
              required: "Please enter pitch title",
            })}
            defaultValue={pitchData?.pitchTitle}
            disabled={isPublished}
          />
          {errors.pitchTitle && (
            <span className="text-danger">{errors.pitchTitle?.message}</span>
          )}
        </Form.Group>

        <Form.Group controlId="description" className="mb-3">
          <Form.Label>Description</Form.Label>
          <Editor
            value={pitchData.description}
            onChange={handleDescription}
            disabled={isPublished}
          />
          {errors.description && (
            <span className="text-danger">{errors.description?.message}</span>
          )}
        </Form.Group>
        <Form.Group controlId="pitchLength" className="mb-3">
          <Form.Label>
            Pitch Length (frontage) (m) <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            type="text"
            //
            defaultValue={pitchData?.pitchLength}
            {...register("pitchLength", {
              required: "Please enter pitch Length",
              pattern: {
                value: /^[+]?[0-9]*\.?[0-9]+$/,
                message: "Please enter a valid number greater than zero.",
              },
            })}
            onChange={(event) => handleChange(event, "pitchLength")}
            disabled={isPublished}
          />
          {errors.pitchLength && (
            <span className="text-danger">{errors.pitchLength?.message}</span>
          )}
        </Form.Group>
        <Form.Group controlId="pitchWidth" className="mb-3">
          <Form.Label>
            Pitch Width (depth) (m) <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            maxLength="10"
            type="text"
            defaultValue={pitchData?.pitchWidth}
            {...register("pitchWidth", {
              required: "Please enter pitch width",
              pattern: {
                value: /^[+]?[0-9]*\.?[0-9]+$/,
                message: "Please enter a valid number greater than zero.",
              },
            })}
            onChange={(event) => handleChange(event, "pitchWidth")}
            disabled={isPublished}
          />
          {errors.pitchWidth && (
            <span className="text-danger">{errors.pitchWidth?.message}</span>
          )}
        </Form.Group>
        <Form.Group controlId="amount" className="mb-3">
          <Form.Label>
            {amountLabel} (£)<span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            maxLength="10"
            type="text"
            defaultValue={pitchData?.amount}
            {...register("amount", {
              required: `Please enter ${amountLabel?.toLowerCase()}`,
              pattern: {
                value: /^[+]?[0-9]*\.?[0-9]+$/,
                message: "Please enter a valid number greater than zero.",
              },
            })}
            onChange={(event) => handleChange(event, "amount")}
            disabled={isPublished}
          />
          {errors.amount && (
            <span className="text-danger">{errors.amount?.message}</span>
          )}
        </Form.Group>
        <Form.Group controlId="totalPitch" className="mb-3">
          <Form.Label>
            Total Available Pitches <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            maxLength="10"
            type="text"
            {...register("description")}
            defaultValue={pitchData?.totalPitch}
            {...register("totalPitch", {
              required: "Please enter  available Pitches ",
              pattern: {
                value: /^[+]?[0-9]*\.?[0-9]+$/,
                message: "Please enter a valid number greater than zero.",
              },
            })}
            onChange={(event) => handleChange(event, "totalPitch")}
            disabled={isPublished}
          />
          {errors.totalPitch && (
            <span className="text-danger">{errors.totalPitch?.message}</span>
          )}
        </Form.Group>

        <Form.Group controlId="maxAllowed" className="mb-3">
          <Form.Label>
            Maximum Individual Applications Allowed{" "}
            <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            maxLength="10"
            type="text"
            defaultValue={pitchData?.maxAllowed}
            {...register("maxAllowed", {
              required: "Please enter max allowed pitch",
              pattern: {
                value: /^[+]?[0-9]*\.?[0-9]+$/,
                message: "Please enter a valid number greater than zero.",
              },
              validate: (value) => {
                const totalPitch = parseFloat(watch("totalPitch"));
                const maxAllowed = parseFloat(value);

                if (maxAllowed > totalPitch) {
                  return "Maximum Individual  cannot be greater than Total Available Pitches";
                }
                return true; // Validation passes
              },
            })}
            onChange={(event) => handleChange(event, "maxAllowed")}
            disabled={isPublished}
          />
          {errors.maxAllowed && (
            <span className="text-danger">{errors.maxAllowed?.message}</span>
          )}
        </Form.Group>
        <Form.Group controlId="refundable" className="mb-3 custom-check">
          <Form.Label>Refundable</Form.Label>
          <Form.Check
            type="checkbox"
            defaultValue={pitchData?.refundable}
            checked={pitchData?.refundable} // Controlled by state
            onChange={handleIsRefundable} // Handle change event
            disabled={isPublished}
          />
        </Form.Group>

        <Form.Group controlId="statusLabel" className="mb-3">
          <Form.Label>Display Status Label</Form.Label>
          <Form.Select
            //as="select"
            {...register("statusLabel")}
            defaultValue={pitchData.statusLabel || ""}
          >
            {statusLabels.map((sl) => (
              <option key={sl?.id} value={sl?.value}>
                {sl?.label}
              </option>
            ))}
          </Form.Select>
        </Form.Group>

        <Form.Group controlId="refundable" className="mb-3 custom-check">
          <Form.Label>Visibility Status</Form.Label>
          <Form.Check
            type="checkbox"
            defaultValue={pitchData?.isActive}
            checked={pitchData?.isActive} // Controlled by state
            onChange={handleIsStatus} // Handle change event
          />
        </Form.Group>

        <button
          className="btn btn-primary mt-3"
          type="button"
          onClick={handleSubmit(onSubmit)}
        >
          Save
        </button>
        {isPublished && pitchData.id && (
          <button
            className="btn btn-primary mt-3 ms-3"
            type="button"
            onClick={(e) => handleOpenModal(e)}
          >
            Reduce Price
          </button>
        )}
      </Form>
      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Reduce Amount</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Amount (£)</Form.Label>
              <Form.Control
                type="text"
                value={reduceAmount}
                onChange={handleInputChange}
                placeholder="Enter amount"
                maxLength={10}
              />
              {error && <Form.Text className="text-danger">{error}</Form.Text>}
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          <Button variant="primary" onClick={onReducePrice}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default injectModels(["application"])(CreatePitch);
